export default "__VITE_ASSET__D8JPnjM6__"